import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Directive, ViewContainerRef } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { HeaderService } from '../../header.service';
import { ProfileService } from '../../profile.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as Globals from '../../globals';
import { UploadIssuanceService } from "../upload-issuance.service";
import { UPLOAD_FILE } from 'app/models/uploadFile';
declare var $: any;
const url = Globals.serviceUrl;

@Component({
  selector: 'app-upload-issuance-hasil',
  templateUrl: './upload-issuance-hasil.component.html',
  styleUrls: ['./upload-issuance-hasil.component.css']
})
export class UploadIssuanceHasilComponent implements OnInit {

  param: any;
  total: number = 0;
  @Input() userProfile: any;
  loading: boolean;
  p: number = 1;
  authMenu: any;
  subtab: number = 1;
  listPemesanan:any;
  detail: any;
  jmlRecords: number = 0;
  series: any[];
  seriesId: number;
  
  constructor(public uploadIssuanceService:UploadIssuanceService,private http: Http, private profileService: ProfileService, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.detail = {};
    this.listPemesanan = this.uploadIssuanceService.listValid;
  }
  ngOnInit() {
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getSeries();
    }
  }
  
  changeTab(type:number){
    this.total = 0;
    if(type==1){
      this.listPemesanan = this.uploadIssuanceService.listValid;
    }else{
      this.listPemesanan = this.uploadIssuanceService.listInvalid;
    }
    for (var i = 0; i < this.listPemesanan.length; i++) {
      this.total += parseFloat(this.listPemesanan[i].Nominal);
    }
    this.jmlRecords = this.listPemesanan.length;
  }

  View(item: any) {
    this.detail = item;
  }

  getSeries() {
    this.loading = true;
    this.http.get(url + 'ritel/issueactive?cdOnline=1&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.series = res.json();
        if (this.series.length > 0) {
          this.seriesId = this.series[0].SERIES_ID;
        } else {
          this.loading = false;
        }
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  download() {
    var dataCsv = [];
    for(var i=0;i<this.listPemesanan.length;i++){
      var data = {
        TrxId:this.listPemesanan[i].TrxId,
        SID:this.listPemesanan[i].SID,
        NamaSeri:this.listPemesanan[i].NamaSeri,
        NoRekDana:this.listPemesanan[i].NoRekDana,
        KodeBank:this.listPemesanan[i].KodeBank,
        NoRekSB:this.listPemesanan[i].NoRekSB,
        KodeSubreg:this.listPemesanan[i].KodeSubreg,
        Nominal:this.listPemesanan[i].Nominal,
        KodeProfesi:this.listPemesanan[i].KodeProfesi,
        KodeJnKelamin:this.listPemesanan[i].KodeJnKelamin,
        TglLahir:this.listPemesanan[i].TglLahir,
        TptLahir:this.listPemesanan[i].TptLahir,
        KodeJnWakaf:this.listPemesanan[i].KodeJnWakaf,
        Aiw:this.listPemesanan[i].Aiw,
        MobileNo:this.listPemesanan[i].MobileNo,
        PhoneNo:this.listPemesanan[i].PhoneNo,
        Email:this.listPemesanan[i].Email,
        PrioritasDiterima:this.listPemesanan[i].PrioritasDiterima,
        NonPrioritasDiterima:this.listPemesanan[i].NonPrioritasDiterima,
        TotalDiterima:this.listPemesanan[i].TotalDiterima,
        StatusCode:this.listPemesanan[i].StatusCode,
        Keterangan:this.listPemesanan[i].Keterangan
      }
      dataCsv.push(data);
      //console.log(result);
    }
    var csvData = this.ConvertToCSV(dataCsv);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData], { type: 'text/csv' });
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    if(this.subtab == 1){
      a.download = 'HasilUploadPemesanan_Valid.csv';
    };
    if(this.subtab == 2){
      a.download = 'HasilUploadPemesanan_Invalid.csv';
    };
    a.click();
  }

  ConvertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0]) {
      //Now convert each value to string and comma-separated
      row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
      var line = '';
      for (var index in array[i]) {
        if (line != '') line += ','

        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  }
  
}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/upload-issuance/upload-issuance-hasil/upload-issuance-hasil.component.ts